import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";

interface DocCalloutProps {
  title?: string;
  variant?: "default" | "green" | "red" | "blue";
  children: React.ReactNode;
}

const variantClasses = {
  default:
    "border-l-primary bg-card",
  green:
    "border-l-success bg-success/10 dark:bg-success/10",
  red:
    "border-l-danger bg-danger/10 dark:bg-danger/10",
  blue:
    "border-l-accent bg-accent/10 dark:bg-accent/10",
};

export function DocCallout({ title, variant = "default", children }: DocCalloutProps) {
  return (
    <Card
      className={cn(
        "my-6 border-0 border-l-4 p-5 shadow-sm",
        variantClasses[variant]
      )}
    >
      {title && (
        <h4 className="mb-2 text-sm font-bold text-foreground">{title}</h4>
      )}
      <div className="text-foreground">{children}</div>
    </Card>
  );
}
